import React from 'react'
import FilterableCandidateList from 'components/FilterableCandidateList'

import HiringSection from 'components/HiringSection'
import FAQ from 'components/FAQ'
import Navigation from 'components/Navigation'
import Footer from 'components/Footer'
import WhitePricingSection from 'components/WhitePricingSection'

import PropTypes from 'prop-types'
import { RegionProvider } from 'clientHelpers/context/regionContext'

import { PageHead } from 'components/PageHead'

const Home = ({ region, apiUrl }) => {
  return (
    <RegionProvider value={{ region }}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
        }}>
        <PageHead />
        <Navigation />
        <FilterableCandidateList apiUrl={apiUrl} />
        <HiringSection />
        <WhitePricingSection />
        <FAQ />
        <Footer />
      </div>
    </RegionProvider>
  )
}

export async function getServerSideProps({ req: { headers } }) {
  // Get user region from offerzen region header
  let region = 'ZA'
  const regionHeaderKey = 'x-offerzen-region'
  if (regionHeaderKey in headers) {
    region = headers[regionHeaderKey]
  }

  const getApiUrl = () => {
    let url =
      process.env.VERCEL_ENV === 'development' || process.env.VERCEL_ENV === 'preview'
        ? process.env.VERCEL_URL
        : process.env.NEXT_PUBLIC_BASE_URL
    if (!url.startsWith('https://') && !url.startsWith('http://')) {
      url = `https://${url}`
    }
    return url
  }

  return {
    props: {
      region,
      apiUrl: getApiUrl(),
    },
  }
}

Home.propTypes = {
  region: PropTypes.string,
  apiUrl: PropTypes.string,
}

export default Home
